import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    apiHead: {
        fontSize: '36px',
        color: '#272727',
        opacity: '1',
        marginTop: '10px',
        marginBottom: '10px'
    },
    apiStatus: {
        color: `#3391FF !important`,
        marginLeft: '10px',
        borderRadius: '5px !important',
        border: `1px solid #3391FF !important`,
        backgroundColor: '#FFF !important'
    },
    apiChip: {
        color: `#3391FF !important`,
        transform: 'scale(0.6)'
    },
    secondHeadApi: {
        backgroundColor: 'white',
        marginLeft: '12px',
        borderRadius: '5px',
        width: '92%',
        height: '58px',
        marginTop: '0px !important',
        paddingTop: '0px important',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            height: 'auto',
            paddingRight: '10px',
            display: 'inline-block'
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: '10px'
        }
    },
    innerheadApi: {
        width: '250px',
        height: '22px',
        padding: '0.001rem',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px'
    },
    innerText: {
        marginTop: '13px',
        height: '19px',
        borderRadius: '0px 8px 8px 0px !important',
        fontWeight: 'bold'
    },
    nameResponsive: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15px'
        }
    },
    nextSet: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            margin: '12px 0px 0px 12px'
        }
    },
    formTextApi: {
        marginTop: '19px',
        color: '#5F6367',
        fontSize: theme.palette.textSizeLarge
    },
    usageContainer: {
        marginTop: '25px',
        borderRadius: '10px',
        border: '1px solid #E8E8E8',
        padding: '13px 13px 43px 13px',
        // width: '1092px',
        backgroundColor: '#F2F5FA',
        fontFamily: 'Montserrat, Tahoma, sans-serif !important'
    },
    sectionValue: {
        marginTop: '18px',
        marginLeft: '15px',
        fontWeight: 'bold',
        fontSize: theme.palette.textSizeLarge
    },
    boxContainer: {
        margin: '12px 12px 10px 12px',
        borderRadius: '5px',
        border: '1px solid #E8E8E8',
        paddingBottom: '35px',
        // width: '285px',
        backgroundColor: '#FFFFFFB3'
    },
    boxSet: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '20px',
        [theme.breakpoints.only('xs')]: {
            marginRight: '10px'
        }
    },
    boxFlex: {
        display: 'flex',
        height: '30px'
    },
    customText: {
        maxHeight: '55%'
    },
    boxHead: {
        background: '#EDEFF1',
        borderRadius: '0px 8px 8px 0px !important',
        margin: '10px 20px 0 0'
    },
    formTextFirst: {
        marginTop: '13px',
        marginLeft: '13px',
        color: '#5F6367',
        fontWeight: '550',
        width: '15%',
        fontSize: theme.palette.textSizeLarge
    },
    firstDaily: {
        padding: '10px',
        overflow: 'hidden',
        marginLeft: '21px'
    },
    innerSection: {
        marginLeft: '15px',
        fontWeight: 'bold',
        fontSize: theme.palette.textSizeExtraLarge
    }
}));
